import groq from 'groq'

import { blogPostWithoutBodyFragment, blogPostOptionsFragment } from './blog'
import { contentFragment } from './content'
import { imageFragment } from './image'
import {
  muxVideoFragment,
  videoAspectRatioFragment,
  videoFragment,
  videoSettingsFragment,
} from './video'
import { buttonStyleFragment } from './link'

const freeformBlockFragment = groq`
  textAlign,
  maxWidth,
  content[] {
    ${contentFragment}
  },
`

const accordionsBlockFragment = groq`
  items[] {
    title,
    "id": _key,
    content[] {
      ${contentFragment}
    },
  },
`

const newsletterFragment = groq`
  service,
  hubSpotFormId,
  klaviyoListID,
  variant,
  title,
  description,
  submit,
  successMsg[] {
    ${contentFragment}
  },
  errorMsg[] {
    ${contentFragment}
  },
  terms[] {
    ${contentFragment}
  }
`

const blogPostCardBlockFragment = groq`
  post->{
    ${blogPostWithoutBodyFragment}
  },
  options {
    ${blogPostOptionsFragment}
  },
`

const contentCarouselBlockCarouselFragment = groq`
  items[] {
    _key,
    _type,
    _type == 'freeform' => {
      "freeform": {
        ${freeformBlockFragment}
      },
    },
    _type == 'photo' => {
      "photo": {
        ${imageFragment}
      },
    },
    _type == 'blogPost' => {
      "blogPost": *[
        _type == "blogPost" &&
        _id == ^._ref
      ][0] {
        ${blogPostWithoutBodyFragment}
      },
    },
    _type == 'video' => {
      "video": {
        ${videoFragment}
      },
    },
    _type == 'linkItem' => {
      "linkItem": {
        title,
        page->{
          "id": _id,
          "type": _type,
          "slug": slug.current,
        },
        image {
          ${imageFragment}
        },
      },
    },
  },
  drag,
  loop,
  showArrows,
  autoSwitch,
  autoSwitchTimeout,
  previewNextSlide,
  showOverflow,
`

const calendlyWidgetFragment = groq`
  url,
  hideEventDetails,
  hideCookieSettings,
`

export const demoFormFragment = groq`
  service,
  hubSpotFormId,
  hubSpotNewsletterFormId,
  klaviyoListID,
  klaviyoNewsletterListID,
  hidePhoneInput,
  submit,
  strings,
  successMsg[] {
    ${contentFragment}
  },
  errorMsg[] {
    ${contentFragment}
  },
  terms[] {
    ${contentFragment}
  },
  newsletterStatement[] {
    ${contentFragment}
  },
  analytics,
  buttonStyle {
    ${buttonStyleFragment},
    fontCase,
  },
`

const iframeBlockFragment = groq`
  title,
  url,
  width,
  height,
`

const htmlBlockFragment = groq`
  code,
`

const mediaTextBlockFragment = groq`
  mediaType,
  image {
    ${imageFragment}
  },
  video {
    muxVideo {
      ${muxVideoFragment}
    },
    ${videoSettingsFragment}
    ${videoAspectRatioFragment}
    borderRadius,
  },
  content[] {
    ${contentFragment}
  },
`

export const blocksFragment = groq`
  _key,
  _type,
  _type == 'freeform' => {
    ${freeformBlockFragment}
  },
  _type == 'accordions' => {
    ${accordionsBlockFragment}
  },
  _type == 'video' => {
    ${videoFragment}
  },
  _type == 'newsletter' => {
    ${newsletterFragment}
  },
  _type == 'blogPostCard' => {
    ${blogPostCardBlockFragment}
  },
  _type == 'contentCarousel' => {
    ${contentCarouselBlockCarouselFragment}
  },
  _type == 'calendlyWidget' => {
    ${calendlyWidgetFragment}
  },
  _type == 'demoForm' => {
    ${demoFormFragment}
  },
  _type == 'iframe' => {
    ${iframeBlockFragment}
  },
  _type == 'html' => {
    ${htmlBlockFragment}
  },
  _type == 'mediaText' => {
    ${mediaTextBlockFragment}
  },
 `
